<template lang="pug">
  .module__main
    .module-content__container
      .users-control__block
        el-button.user-add__btn(type="primary" size="mini" @click="openUserAdding()") Добавить пользователя
        el-button.user-add__btn(v-if="false" type="warning" size="mini" @click="openUser2fa()") 2FA
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="users"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="name" label="Логин" width="160" sortable)
              template(v-slot:default="scope")
                span {{ scope.row.name }}
                span.ml5(v-if="scope.row.saudiAccount") ({{ scope.row.saudiAccount.name }})
            el-table-column(prop="role" label="Роль" width="100" sortable)
              template(v-slot:default="scope")
                span {{ roles[scope.row.role] || scope.row.role }}
            el-table-column(prop="projects" label="Проекты" width="150")
              template(v-slot:default="scope")
                .user-projects__container(v-if="editingProjects.username === scope.row.name")
                  el-select(size="mini" v-model="editingProjects.value" multiple allow-create filterable :default-first-option="true")
                    el-option(v-for="project in usersProjects" :label="project" :value="project" :key="`user-${scope.row.name}-project-${project}`")
                  .balance__buttons.ml5
                    .balance__btn.mr5
                      el-button(circle size="mini" icon="el-icon-check" type="success" @click="updateUserProject()")
                    .balance__btn
                    el-button(circle size="mini" icon="el-icon-close" type="danger" @click="resetProjectChange()")
                .user-projects__container(v-else)
                  .projects__container.mr5
                    div(v-for="project in scope.row.projects" :key="`user-${scope.row.name}-current-project-${project}`") {{ project }}
                  i.el-icon-edit.cursor-pointer(@click="activateProjectChange(scope.row.name, scope.row.projects)")
            el-table-column(label="Активен" width="100")
              template(v-slot:default="scope")
                .user-active-change__btn(
                  @click="changeUserActiveStatus(scope.row)"
                  :class="scope.row.active ? 'active' : 'inactive'"
                )
                  i.el-icon-check(v-if="scope.row.active")
                  i.el-icon-close(v-else)
            el-table-column(label="Комиссия вывод" width="150")
              template(v-slot:default="scope")
                .user-active-change__btn(
                  @click="changeUserIncludeFeeInAmount(scope.row)"
                  :class="scope.row.includeFeeInAmount ? 'active' : 'inactive'"
                )
                  i.el-icon-check(v-if="scope.row.includeFeeInAmount")
                  i.el-icon-close(v-else)
            el-table-column(label="Баланс" width="140")
              template(v-slot:default="scope")
                .user-balances__container
                  .user-balance__container
                    .val {{ scope.row.balance }} BTC
                    .user-balance-change__buttons
                      .user-balance-change__btn.background-success(@click="activateBalance(scope.row, 'plus', 'BTC')") +
                      .user-balance-change__btn.background-danger(@click="activateBalance(scope.row, 'minus', 'BTC')") -
                  .user-balance__container
                    .val {{ scope.row.balanceUsdt }} USDT
                    .user-balance-change__buttons
                      .user-balance-change__btn.background-success(@click="activateBalance(scope.row, 'plus', 'USDT')") +
                      .user-balance-change__btn.background-danger(@click="activateBalance(scope.row, 'minus', 'USDT')") -
            el-table-column(prop="balanceDep" label="В заявках" width="140")
              template(v-slot:default="scope")
                div
                  div {{ scope.row.balanceDep }} BTC
                  div {{ scope.row.balanceDepUsdt }} USDT
            el-table-column(label="Комиссия" width="160")
              template(v-slot:default="scope")
                .user-fee__container(v-if="editingFee.username === scope.row.name")
                  .fee__title {{ editingFee.crypto_type }} {{ editingFee.is_clean ? 'Чистый' : 'Грязный' }}
                  el-input(type="number" size="mini" v-model="editingFee.value" :min="0")
                  .balance__buttons.ml5
                    .balance__btn.mr5
                      el-button(circle size="mini" icon="el-icon-check" type="success" @click="updateUserFee()")
                    .balance__btn
                    el-button(circle size="mini" icon="el-icon-close" type="danger" @click="resetFeeChange()")
                .user-fee__container(v-else)
                  .fee-crypto__container(v-for="(options, cryptoType) in feesOptions")
                    .fee__container(v-for="option in options")
                      .fee__title {{ cryptoType }} {{ option.isClean ? 'Чистый' : 'Грязный' }}
                      span.mr5.ml5 {{ scope.row[option.settingName] }}
                      i.el-icon-edit.cursor-pointer(@click="activateFeeChange(scope.row.name, scope.row[option.settingName], cryptoType, option.isClean)")
            el-table-column(label="Кредит" width="160")
              template(v-slot:default="scope")
                .user-balances__container(v-if="editingCredit.username === scope.row.name")
                  .balance__title {{ editingCredit.crypto_type }}
                  .user-balance__container
                    el-input(type="number" size="mini" v-model="editingCredit.value" :min="0")
                    .balance__buttons.ml5
                      .balance__btn.mr5
                        el-button(circle size="mini" icon="el-icon-check" type="success" @click="updateUserBalanceCredit()")
                      .balance__btn
                      el-button(circle size="mini" icon="el-icon-close" type="danger" @click="resetBalanceCreditChange()")
                .user-balances__container(v-else)
                  .user-balance__container
                    span.mr5 {{ scope.row.balanceCredit }} BTC
                    i.el-icon-edit.cursor-pointer(@click="activateBalanceCreditChange(scope.row.name, scope.row.balanceCredit, 'BTC')")
                  .user-balance__container
                    span.mr5 {{ scope.row.balanceCreditUsdt }} USDT
                    i.el-icon-edit.cursor-pointer(@click="activateBalanceCreditChange(scope.row.name, scope.row.balanceCreditUsdt, 'USDT')")
            el-table-column(label="Лимиты" width="160")
              template(v-slot:default="scope")
                .user-balances__container(v-if="editingLimits.username === scope.row.name")
                  .balance__title {{ editingLimits.crypto_type }}
                  .user-balance__container
                    .limits__container
                      el-input(type="number" size="mini" v-model="editingLimits.min" :min="0")
                      el-input(type="number" size="mini" v-model="editingLimits.max" :min="0")
                    .balance__buttons.ml5
                      .balance__btn.mr5
                        el-button(circle size="mini" icon="el-icon-check" type="success" @click="updateUserLimits()")
                      .balance__btn
                      el-button(circle size="mini" icon="el-icon-close" type="danger" @click="resetLimitsChange()")
                .user-balances__container(v-else)
                  .user-balance__container
                    span.mr5 {{ scope.row.limitMin }} - {{ scope.row.limitMax }} BTC
                    i.el-icon-edit.cursor-pointer(@click="activateLimitsChange(scope.row.name, scope.row.limitMin, scope.row.limitMax, 'BTC')")
                  .user-balance__container
                    span.mr5 {{ scope.row.limitMinUsdt }} - {{ scope.row.limitMaxUsdt }} USDT
                    i.el-icon-edit.cursor-pointer(@click="activateLimitsChange(scope.row.name, scope.row.limitMinUsdt, scope.row.limitMaxUsdt, 'USDT')")
            el-table-column(v-if="false" label="Разрешенные IP" width="200")
              template(v-slot:default="scope")
                .allowed-ips__container
                  .allowed-ip__container(v-for="ip in scope.row.allowed_ips" :key="`allowed-ip-${ip}`")
                    span {{ ip }}
                    i.el-icon-delete.color-danger.ip__btn(@click="deleteUserIp(scope.row.name, scope.row.allowed_ips, ip)")
                  .add-ip__input(v-if="addingIp.user_name === scope.row.name")
                    el-input(size="mini" v-model="addingIp.ip")
                    el-button(icon="el-icon-check" circle size="mini" :disabled="!addingIp.ip" @click="addUserAllowedIp")
                  .add-ip__btn(v-else @click="openAddIp(scope.row.name, scope.row.allowed_ips)")
                    i.el-icon-plus
            el-table-column(label="Управление" width="200")
              template(v-slot:default="scope")
                .table-buttons__container
                  el-button(type="primary" size="mini" @click="activateSystemSettings(scope.row)") Системные настройки
    el-dialog(:visible.sync="isUserAdding" :before-close="resetUserAdding" title="Добавление пользователя" width="50%")
      AddUser(v-if="isUserAdding" @resetUserAdd="resetUserAdding" @updateUsers="loadUsersList")
    el-dialog(:visible.sync="is2faOpened" :before-close="resetUser2fa" title="Двухфакторная аутентификация" width="50%")
      TwoFactor(v-if="is2faOpened" @resetUser2fa="resetUser2fa")
    el-dialog(:visible.sync="isSystemSettingsOpened" :before-close="resetSystemSettings" :title="systemSettingsTitle" width="30%")
      .dialog__container
        .dialog-input__block
          .title Пароль пользователя (оставьте пустым, если не хотите менять)
          el-input(type="password" v-model="systemSettings.password" placeholder="Пароль")
        .dialog-input__block
          .title Аккаунт Saudi
          el-select(v-model="systemSettings.saudiAccount" placeholder="Аккаунт")
            el-option(v-for="account in accountsNames" :label="account" :value="account" :key="`saudi-account-${account}`")
        .dialog__buttons
          el-button(type="success" :disabled="!canChangeSystemSettings" @click="updateSystemSettings()") Сохранить
          el-button(type="danger" @click="resetSystemSettings()") Отменить
    el-dialog(v-if="isAdmin" :visible.sync="isBalanceChanging" :before-close="resetBalance" :title="balanceChangeTitle" width="40%")
      .dialog__container
        .dialog-input__block
          .title Введите количество криптовалюты
          el-input(type="number" v-model="balanceChange.change_value" placeholder="Количество крипты")
        .dialog__buttons
          el-button(type="success" @click="changeUserBalance()") {{ balanceChange.change_mode === 'plus' ? 'Добавить' : 'Убавить' }}
          el-button(type="danger" @click="resetBalance()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { CREATE_USER, EDIT_BALANCE, EDIT_USER, LOAD_USERS_PROJECTS, LOAD_USERS_LIST } from '@/store/const/user';
import AddUser from './AddUser';
import TwoFactor from './TwoFactor';
import instruments from '../../mixins/instruments';
import { LOAD_ACCOUNTS_NAMES } from '@/store/const/accounts';

export default {
  name: 'Users',
  components: {
    AddUser,
    TwoFactor,
  },
  mixins: [instruments],
  data() {
    return {
      isUserAdding: false,
      addingIp: {
        user_name: '',
        user_ips: [],
        ip: '',
      },
      is2faOpened: false,
      isSystemSettingsOpened: false,
      isBalanceChanging: false,
      balanceChange: {
        username: '',
        crypto_type: '',
        change_mode: 'plus',
        change_value: 0,
      },
      editingFee: {
        username: '',
        crypto_type: '',
        is_clean: false,
        value: 0,
      },
      editingCredit: {
        username: '',
        crypto_type: '',
        value: 0,
      },
      editingLimits: {
        username: '',
        crypto_type: '',
        min: 0,
        max: 0,
      },
      editingProjects: {
        username: '',
        value: [],
      },
      systemSettings: {
        username: '',
        password: '',
        saudiAccount: '',
      },
      originalSystemSettingsString: '',
      feesOptions: {
        BTC: [
          { isClean: false, settingName: 'fee' },
          { isClean: true, settingName: 'feeClean' },
        ],
        USDT: [
          { isClean: false, settingName: 'feeUsdt' },
          { isClean: true, settingName: 'feeCleanUsdt' },
        ],
      },
    };
  },
  mounted() {
    this.loadUsersList();
    this.loadAccountsNames();
    this.loadUsersProjects();
  },
  computed: {
    ...mapGetters(['loading', 'error']),
    ...mapGetters('user', ['users', 'isAdmin', 'username', 'usersProjects']),
    ...mapGetters('accounts', ['accountsNames']),
    ...mapGetters('settings', ['roles']),
    isLoading() {
      return this.loading(LOAD_USERS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_USERS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_USERS_LIST);
    },
    balanceChangeTitle() {
      return this.balanceChange.change_mode === 'plus'
        ? `Добавление баланса пользователю ${this.balanceChange.username}`
        : `Убавление баланса пользователя ${this.balanceChange.username}`;
    },
    systemSettingsTitle() {
      return `Системные настройки пользователя ${this.systemSettings.username}`;
    },
    canChangeSystemSettings() {
      return JSON.stringify(this.systemSettings) !== this.originalSystemSettingsString;
    },
  },
  methods: {
    ...mapActions('user', {
      loadUsersList: LOAD_USERS_LIST,
      loadUsersProjects: LOAD_USERS_PROJECTS,
      addNewUser: CREATE_USER,
      editUser: EDIT_USER,
      editBalance: EDIT_BALANCE,
    }),
    ...mapActions('accounts', {
      loadAccountsNames: LOAD_ACCOUNTS_NAMES,
    }),
    openUserAdding() {
      this.isUserAdding = true;
    },
    resetUserAdding() {
      this.isUserAdding = false;
    },
    openUser2fa() {
      this.is2faOpened = true;
    },
    resetUser2fa() {
      this.is2faOpened = false;
    },
    async startEditUser(name, data, confirmMessage, methodOnSuccess) {
      this.$confirm(confirmMessage || 'Подтвердите изменение пользователя', 'Изменение пользователя')
        .then(async () => {
          const request = await this.editUser({ name, data });
          const successMethod = methodOnSuccess ? [methodOnSuccess, this.loadUsersList] : this.loadUsersList;
          await this.notifyRequestResult({
            request,
            successMessage: `Пользователь ${name} успешно изменен`,
            methodOnSuccess: successMethod,
          });
        })
        .catch(() => {
          this.$message.info('Изменение пользователя отменено');
        });
    },
    async changeUserActiveStatus(user) {
      await this.startEditUser(
        user.name,
        { active: !user.active },
        `Вы уверены, что хотите ${user.active ? 'деактивировать' : 'активировать'} пользователя?`,
      );
    },
    async changeUserIncludeFeeInAmount(user) {
      await this.startEditUser(
        user.name,
        { includeFeeInAmount: !user.includeFeeInAmount },
        `Вы уверены, что хотите ${user.includeFeeInAmount ? 'отлючить' : 'включить'} комиссию в выводы пользователя?`,
      );
    },
    openAddIp(name, ips) {
      this.addingIp.ip = '';
      this.addingIp.user_ips = ips;
      this.addingIp.user_name = name;
    },
    async addUserAllowedIp() {
      const isNewIpValid = this.validateIPAddress(this.addingIp.ip);
      if (!isNewIpValid) {
        return this.$message.warning('Введенный IP-адрес не валиден!');
      }
      if (this.addingIp.user_ips.includes(this.addingIp.ip)) {
        return this.$message.warning('Введенный IP-адрес уже добавлен в список');
      }
      await this.startEditUser(
        this.addingIp.user_name,
        { allowed_ips: [...this.addingIp.user_ips, this.addingIp.ip] },
        `Вы уверены, что хотите добавить IP-адрес к разрешенным у пользователя?`,
        this.resetAddIp,
      );
    },
    async deleteUserIp(user, allowedIps, deletingIp) {
      await this.startEditUser(
        user,
        { allowed_ips: allowedIps.filter((c) => c !== deletingIp) },
        `Вы уверены, что хотите удалить IP-адрес из разрешенных у пользователя?`,
      );
    },
    resetAddIp() {
      this.addingIp.ip = '';
      this.addingIp.user_ips = [];
      this.addingIp.user_name = '';
    },

    activateBalance(user, mode, cryptoType) {
      this.balanceChange.username = user.name;
      this.balanceChange.change_value = 0;
      this.balanceChange.change_mode = mode;
      this.balanceChange.crypto_type = cryptoType;
      this.isBalanceChanging = true;
    },
    resetBalance() {
      this.balanceChange = {
        username: '',
        change_mode: 'plus',
        change_value: 0,
      };
      this.isBalanceChanging = false;
    },
    async changeUserBalance() {
      this.$confirm(`Вы уверены, что хотите изменить баланс пользователя?`, 'Изменение пользователя')
        .then(async () => {
          if (!this.balanceChange.change_value) {
            this.$message.info(
              `Введите количество криптовалюты ${this.balanceChange.crypto_type} для ${this.balanceChange.change_mode === 'plus' ? 'добавления' : 'убавление'}`,
            );
            return;
          } else if (this.balanceChange.change_value < 0) {
            this.$message.info('Значение должно быть положительным');
            return;
          }
          const request = await this.editBalance({
            name: this.balanceChange.username,
            data: {
              mode: this.balanceChange.change_mode,
              value: parseFloat(this.balanceChange.change_value),
              cryptoType: this.balanceChange.crypto_type,
            },
          });
          await this.notifyRequestResult({
            request,
            successMessage: 'Баланс успешно изменен',
            errorMessage: 'Ошибка изменения баланса',
            methodOnSuccess: [this.resetBalance, this.loadUsersList],
          });
        })
        .catch(() => {
          this.$message.info('Изменение баланса отменено');
        });
    },
    activateProjectChange(username, currentProject) {
      this.editingProjects.value = currentProject;
      this.editingProjects.username = username;
    },
    resetProjectChange() {
      this.editingProjects.username = '';
      this.editingProjects.value = 0;
    },
    async updateUserProject() {
      await this.startEditUser(
        this.editingProjects.username,
        { projects: this.editingProjects.value },
        `Вы уверены, что хотите изменить группу пользователя ${this.editingProjects.username}?`,
        async () => {
          this.resetProjectChange();
          await this.loadUsersProjects();
        },
      );
    },
    activateFeeChange(username, currentFee, cryptoType, isClean) {
      this.editingFee.value = currentFee;
      this.editingFee.crypto_type = cryptoType;
      this.editingFee.is_clean = isClean;
      this.editingFee.username = username;
    },
    resetFeeChange() {
      this.editingFee.username = '';
      this.editingFee.value = 0;
      this.editingFee.crypto_type = '';
      this.editingFee.is_clean = false;
    },
    async updateUserFee() {
      const feeSettingName = this.editingFee.is_clean
        ? this.editingFee.crypto_type === 'BTC'
          ? 'feeClean'
          : 'feeCleanUsdt'
        : this.editingFee.crypto_type === 'BTC'
          ? 'fee'
          : 'feeUsdt';
      await this.startEditUser(
        this.editingFee.username,
        { [feeSettingName]: parseFloat(this.editingFee.value) },
        `Вы уверены, что хотите изменить комиссию пользователя ${this.editingFee.username}?`,
        this.resetFeeChange,
      );
    },
    activateBalanceCreditChange(username, currentCredit, cryptoType) {
      this.editingCredit.value = currentCredit;
      this.editingCredit.crypto_type = cryptoType;
      this.editingCredit.username = username;
    },
    resetBalanceCreditChange() {
      this.editingCredit.username = '';
      this.editingCredit.crypto_type = '';
      this.editingCredit.value = 0;
    },
    async updateUserBalanceCredit() {
      const balanceCreditSettingName = this.editingCredit.crypto_type === 'BTC' ? 'balanceCredit' : 'balanceCreditUsdt';
      await this.startEditUser(
        this.editingCredit.username,
        { [balanceCreditSettingName]: parseFloat(this.editingCredit.value) },
        `Вы уверены, что хотите изменить кредит пользователя ${this.editingCredit.username}?`,
        this.resetBalanceCreditChange,
      );
    },
    activateLimitsChange(username, currentMin, currentMax, cryptoType) {
      this.editingLimits.min = currentMin;
      this.editingLimits.max = currentMax;
      this.editingLimits.crypto_type = cryptoType;
      this.editingLimits.username = username;
    },
    resetLimitsChange() {
      this.editingLimits.username = '';
      this.editingLimits.min = 0;
      this.editingLimits.max = 0;
      this.editingLimits.crypto_type = '';
    },
    async updateUserLimits() {
      const limitMin = parseFloat(this.editingLimits.min);
      const limitMax = parseFloat(this.editingLimits.max);
      if (limitMin < 0 || limitMax < 0) {
        return this.$message.warning('Лимиты должны быть больше 0');
      }
      if (limitMin > limitMax) {
        return this.$message.warning('Минимальный лимит не может превышать максимальный');
      }
      const limitMinSettingName = this.editingLimits.crypto_type === 'BTC' ? 'limitMin' : 'limitMinUsdt';
      const limitMaxSettingName = this.editingLimits.crypto_type === 'BTC' ? 'limitMax' : 'limitMaxUsdt';
      await this.startEditUser(
        this.editingLimits.username,
        { [limitMinSettingName]: limitMin, [limitMaxSettingName]: limitMax },
        `Вы уверены, что хотите изменить лимиты ${this.editingLimits.crypto_type} у пользователя ${this.editingCredit.username}?`,
        this.resetLimitsChange,
      );
    },
    activateSystemSettings(user) {
      this.systemSettings.saudiAccount = user.saudiAccount?.name || '';
      this.systemSettings.username = user.name;
      this.originalSystemSettingsString = JSON.stringify(this.systemSettings);
      this.isSystemSettingsOpened = true;
    },
    resetSystemSettings() {
      this.isSystemSettingsOpened = false;
      this.systemSettings.username = '';
      this.systemSettings.saudiAccount = '';
      this.systemSettings.password = '';
      this.originalSystemSettingsString = '';
    },
    async updateSystemSettings() {
      if (!this.systemSettings.password && !this.systemSettings.saudiAccount) {
        this.$message.info('Не обнаружено изменений');
        return this.resetSystemSettings();
      }
      const data = {};
      if (this.systemSettings.password) {
        data.password = this.systemSettings.password;
      }
      if (this.systemSettings.saudiAccount) {
        data.saudiAccount = this.systemSettings.saudiAccount;
      }
      await this.startEditUser(
        this.systemSettings.username,
        data,
        `Вы уверены, что хотите изменить системные настройки пользователя ${this.systemSettings.username}?`,
        this.resetSystemSettings,
      );
    },
  },
};
</script>
<style scoped>
.users-control__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.user-add__btn {
  width: 160px;
}

.token__val {
  font-family: monospace;
  font-size: 11px;
  cursor: pointer;
}

.ip__btn {
  margin-left: 5px;
  cursor: pointer;
}

.allowed-ips__container {
  text-align: center;
}

.add-ip__input {
  display: flex;
}

.add-ip__btn {
  display: flex;
  text-align: center;
  margin: auto;
  font-size: 10px;
  border: 1px solid #d1cece;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.user-active-change__btn {
  cursor: pointer;
}

.user-projects__container {
  display: flex;
  align-items: center;
}

.user-balance__container {
  display: flex;
  align-items: center;
  border: 1px solid #ebeef5;
}

.user-balance-change__buttons {
  margin-left: 10px;
}

.user-balance-change__btn {
  height: 15px;
  width: 15px;
  border: 1px solid #6a6a6a;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px auto;
  color: white;
  cursor: pointer;
}

.balance__buttons {
  display: flex;
}

.user-fee__container {
  font-size: 10px;
}

.fee__container {
  border: 1px solid #ebeef5;
  padding: 2px;
  display: flex;
}

.fee__container:hover {
  border: 1px solid #b7b7b7;
}

.fee-crypto__container {
  margin-bottom: 5px;
}

.user-crypto-type__img {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}

.user-crypto-type__img.crypto-BTC {
  background-image: url('~@/assets/btc-logo.svg');
}

.user-crypto-type__img.crypto-XMR {
  background-image: url('~@/assets/xmr-logo.svg');
}

.user-crypto-type__img.crypto-USDT {
  background-image: url('~@/assets/usdt-logo.svg');
}

.projects__container {
  display: flex;
  flex-direction: column;
  padding: 2px;
  border: 1px solid #ebeef5;
}
</style>
